import iView from 'iview';
import LutticaComponents from '@/components/LutticaComponents';
import CloudIView from '@/components/CloudIView';
// import BaiduMap from 'vue-baidu-map';
import Print from '@/utils/print';
import VerifyPassword from '@/components/LutticaComponents/VerifyPassword/index';
import LutticaMessage from '@/components/LutticaComponents/LutticaMessage/index';
import htmlToPDF from '@/utils/vendor/htmlToPdf';
import NewPrint from '@/utils/nprint';
// 富文本框
import VueQuillEditor from 'vue-quill-editor';

// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default Vue => {
  Vue.use(iView);
  Vue.use(CloudIView);
  Vue.use(LutticaComponents);
  Vue.use(htmlToPDF);
  // Vue.use(BaiduMap, {
  //   ak: 'VwVqSVqrG8R4Q0USpVOkXljH',
  // });
  Vue.use(Print);
  Vue.use(VerifyPassword);
  Vue.use(LutticaMessage);
  Vue.use(VueQuillEditor);
  Vue.use(NewPrint);
};
